import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

// TODO clean up the window to have a standard intial app state
interface ICustomWindow extends Window {
  initialAppState?: any;
}

const customWindow: ICustomWindow = window;

let reactPlugin = null;
let appInsights = null;

const ApplicationInsightService = {
  initialize: () => {
    try {
      if (reactPlugin && appInsights) return;
      const browserHistory = createBrowserHistory({ basename: '' });
      reactPlugin = new ReactPlugin();
      appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: customWindow.initialAppState.instrumentationKey,
          extensions: [reactPlugin],
          extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory },
          },
          enableAutoRouteTracking: true,
        },
      });
      appInsights.loadAppInsights();
      appInsights.trackPageView();

      appInsights.addTelemetryInitializer(envelope => {
        if (envelope && customWindow.initialAppState.user) {
          envelope.tags['ai.user.id'] = customWindow.initialAppState.user.id;
          envelope.baseData.institutionId =
            customWindow.initialAppState.user.institutionId;
          envelope.data.institutionId =
            customWindow.initialAppState.user.institutionId;
        }
      });
    } catch (e) {
      console.log(e);
    }
  },
  getAppInsights: () => appInsights,
  getReactPlugin: () => reactPlugin,
};

export default ApplicationInsightService;
